import moment from "moment";

/**
 * Requirements §5.1: every number on these screens is either a snapshot
 * (true right now, unaffected by the date range) or a period figure (what
 * happened inside the range), and the UI must say which. The original
 * design mixed both in one KPI row, which only works while the range is
 * "last 30 days" — pick any historical range and the page silently shows
 * today's headcount beside last quarter's revenue.
 *
 * One component so the marker can't drift between tabs.
 *
 * `description` is an optional one-line explanation of the band shown next
 * to its colour-coded label (e.g. "Where your subscription business stands
 * right now"). `periodRangeText`, when given, replaces the default "for
 * {{range}}" marker on a period band with an already-formatted date range —
 * callers that don't have one fall back to `rangeLabel`. `metaNote` trails
 * after that marker (e.g. Attention's "no period selector: this is a
 * worklist, not a report").
 */
const StatBand = ({
  kind,
  asAt,
  rangeLabel,
  periodRangeText,
  title,
  description,
  metaNote,
  children,
  t,
}) => (
  <section className={`stat-band stat-band--${kind}`}>
    <header className="stat-band__header">
      <span className="stat-band__label" data-kind={kind}>
        <span className={`stat-band__dot stat-band__dot--${kind}`} />
        <h3 data-kind={kind}>{title}</h3>
      </span>
      {description && <p className="stat-band__description">{description}</p>}
      <span className="stat-band__meta">
        {kind === "snapshot"
          ? t("income.bands.asAt", {
              time: asAt ? moment(asAt).format("MMM D, YYYY, HH:mm") : "—",
            })
          : periodRangeText ||
            t("income.bands.forRange", { range: rangeLabel })}
        {metaNote && ` · ${metaNote}`}
      </span>
    </header>
    <div className="stat-cards">{children}</div>
  </section>
);

export default StatBand;
